import { render, staticRenderFns } from "./TrackerPreview.vue?vue&type=template&id=af827470&scoped=true&"
import script from "./TrackerPreview.vue?vue&type=script&setup=true&lang=js&"
export * from "./TrackerPreview.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af827470",
  null
  
)

export default component.exports